var _path, _path2, _path3, _path4, _rect, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "loader-logo",
    width: 357,
    height: 514,
    viewBox: "0 0 357 514",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.457 205.674L302.494 181.211C298.104 154.37 276.169 145.232 265.599 144.063L222.457 205.674Z",
    fill: "url(#paint0_linear_34_214)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M294.49 161.431C301.618 170.37 303.098 182.521 302.947 187.404C302.101 253.727 252.659 286.718 228.044 294.922L67.9678 344C59.9942 330.832 58.0008 315.56 58.0008 309.57C58.0008 266.563 89.5126 245.945 105.269 241.012L222.909 205.072C236.098 201.045 266.643 191.723 283.315 186.649C299.987 181.575 297.712 167.672 294.49 161.431Z",
    fill: "url(#paint1_linear_34_214)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 138.326L58.4631 162.789C62.8536 189.63 84.788 198.768 95.3578 199.938L138.5 138.326Z",
    fill: "url(#paint2_linear_34_214)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4669 182.57C59.339 173.63 57.8591 161.479 58.0101 156.596C58.8559 90.2731 108.298 57.2827 132.913 49.0779L292.989 0C300.963 13.168 302.956 28.44 302.956 34.43C302.956 77.4373 271.444 98.0551 255.689 102.988L138.048 138.928C124.859 142.955 94.314 152.277 77.642 157.351C60.9699 162.425 63.2452 176.328 66.4669 182.57Z",
    fill: "url(#paint3_linear_34_214)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 440,
    width: 69.6072,
    height: 69.6072,
    rx: 5.04673,
    stroke: "#2B4469",
    strokeWidth: 5.22054,
    shapeRendering: "crispEdges"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8786 453.147C51.2803 453.147 58.1714 458.911 58.1714 468.433C58.1714 477.955 51.2803 483.719 39.8786 483.719H29.0408V497H22.7761V453.147H39.8786ZM39.6907 478.269C47.7094 478.269 51.9067 474.698 51.9067 468.433C51.9067 462.169 47.7094 458.598 39.6907 458.598H29.0408V478.269H39.6907Z",
    fill: "#2B4469"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.659 497.313C107.144 497.313 100.879 494.87 97.6842 491.362L99.1251 488.981C102.132 492.114 107.708 494.494 113.596 494.494C122.367 494.494 126.251 490.673 126.251 485.912C126.251 472.756 98.8745 480.649 98.8745 464.486C98.8745 458.284 103.636 452.834 114.411 452.834C119.235 452.834 124.246 454.338 127.629 456.781L126.439 459.349C122.805 456.844 118.358 455.653 114.411 455.653C105.891 455.653 102.069 459.6 102.069 464.424C102.069 477.58 129.446 469.811 129.446 485.724C129.446 491.926 124.497 497.313 113.659 497.313ZM156.032 453.147C167.057 453.147 173.698 458.66 173.698 467.932C173.698 477.141 167.057 482.654 156.032 482.654H143.502V497H140.307V453.147H156.032ZM156.032 479.772C165.429 479.772 170.44 475.45 170.44 467.932C170.44 460.352 165.429 456.029 156.032 456.029H143.502V479.772H156.032ZM215.04 497L209.401 484.659H183.967L178.391 497H174.946L195.118 453.147H198.313L218.485 497H215.04ZM185.22 481.965H208.211L196.684 456.656L185.22 481.965ZM244.378 497.313C231.347 497.313 221.637 487.854 221.637 475.074C221.637 462.294 231.347 452.834 244.378 452.834C250.58 452.834 256.155 454.839 259.977 458.911L257.972 460.978C254.213 457.282 249.64 455.779 244.503 455.779C233.289 455.779 224.832 464.048 224.832 475.074C224.832 486.1 233.289 494.369 244.503 494.369C249.64 494.369 254.213 492.803 257.972 489.107L259.977 491.174C256.155 495.246 250.58 497.313 244.378 497.313ZM273.873 494.118H300.936V497H270.678V453.147H299.997V456.029H273.873V473.32H297.24V476.139H273.873V494.118ZM346.665 497H343.031L332.569 482.341C331.191 482.529 329.813 482.654 328.309 482.654H315.78V497H312.585V453.147H328.309C339.335 453.147 345.976 458.66 345.976 467.932C345.976 474.886 342.217 479.71 335.702 481.652L346.665 497ZM315.78 479.835H328.309C337.706 479.835 342.718 475.45 342.718 467.932C342.718 460.352 337.706 456.029 328.309 456.029H315.78V479.835Z",
    fill: "#2B4469"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34_214",
    x: 0.548649,
    y: 437.39,
    width: 76.5099,
    height: 76.5099,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.841121
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.420561
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_214",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_214",
    x1: 277.285,
    y1: 116.277,
    x2: 329.352,
    y2: 177.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A1CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34_214",
    x1: 99.9829,
    y1: 527.023,
    x2: 434.658,
    y2: 247.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#132666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#6A95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34_214",
    x1: 83.6726,
    y1: 227.723,
    x2: 31.6056,
    y2: 166.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A1CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34_214",
    x1: 260.974,
    y1: -183.023,
    x2: -73.7006,
    y2: 96.1626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#132666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#6A95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderLogo);
export default __webpack_public_path__ + "static/media/loader_logo.b3c908e25603431813324bd0b5ae389b.svg";
export { ForwardRef as ReactComponent };